import AWS from 'aws-sdk'
import config from '@/config'

AWS.config.update({
  httpOptions: { timeout: 1800000 },
  region: config.awsRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: config.identityPoolId,
  }),
})

AWS.config.credentials.get(function (err) {
  if (err) {
    /* eslint-disable no-console */
    console.error(`failure to authenticate by Cognito: ${err}`)
  }
})

export default new AWS.S3({
  params: { Bucket: config.s3BucketName },
})
